<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <fis ref="fis"></fis>
<v-dialog v-model="showLeaveModal" max-width="400" persistent>
  <v-card>
    <v-card-title class="headline">
      Uyarı
    </v-card-title>

    <v-card-text>
      Borç ve Alacak değerleri tutmuyor. Çıkmak istiyor musunuz?
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="grey" text @click="cancelLeave">
        Hayır
      </v-btn>
      <v-btn color="red" text @click="confirmLeave">
        Evet
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t("Receipt-Detail") }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom="" left>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title
                    >Html {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>

                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <v-flex xs12 v-if="fisData != null">
        <v-tabs
          style="width: 100%"
          dark=""
          v-model="modelActive"
          color="blue darken-3"
          slot="extension"
          slider-
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#0">
            {{ $t("tab_general") }}
          </v-tab>
          <v-tab-item :id="'0'" style="width: 100%" class="pa-3">
            <!--listeleme-->
            <v-container fluid grid-list-sm>
              <!-- v-for="item in cardItems"
        v-bind:key="item.SiraNo" -->
              <v-flex pb-3 xs12 sm12 md12 v-if="fisData != null">
                <v-card width="100%" class="elevation-3 pt-3 pl-3 pb-1">
                  <v-layout row wrap align-center justify-end>
                    <v-flex xs12 sm6 md3>
                      <v-layout row wrap>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text caption"
                        >
                          <v-chip
                            color="#67768f"
                            outline
                            text-color="#67768f"
                            small
                          >
                            <v-avatar>
                              <v-icon>schedule</v-icon>
                            </v-avatar>
                            {{ fisData.RecieptDate | dateformat }}
                          </v-chip>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="
                            font-weight-medium
                            text-align-bottom
                            grey--text
                            caption
                          "
                        >
                          <v-chip
                            color="#67768f"
                            outline
                            text-color="#67768f"
                            small
                          >
                            <v-avatar>
                              <v-icon>receipt</v-icon>
                            </v-avatar>
                            {{ desingRecieptNumber(fisData.RecieptNumber) }}
                          </v-chip>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-medium grey--text subheading"
                        style="color: #67768f"
                      >
                        <v-chip
                          color="primary"
                          label
                          text-color="primary"
                          outline
                        >
                          {{ fisData.ReciptType.RecieptTypeName }}
                        </v-chip>
                      </v-flex>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-layout row wrap>
                        <v-flex
                          xs12
                          sm12
                          md12
                          class="font-weight-medium grey--text subheading"
                        >
                          <v-chip
                            color="primary"
                            label
                            text-color="primary"
                            outline
                          >
                            {{ fisData.Center.CenterName }}
                          </v-chip>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f">{{ $t("Debit") }}:</span>
                        {{ fisData.TotalDept.toFixed(2) }}
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f">{{ $t("Credit") }}:</span>
                        {{ fisData.TotalCredit.toFixed(2) }}
                      </v-flex>
                      <v-flex
                        v-if="fisData.TotalBalance > 0"
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f"
                          >{{ $t("Balance") }}:</span
                        >
                        {{ fisData.TotalBalance.toFixed(2) }}
                        <span class="red--text caption"
                          >{{ $t("Debit") }}
                        </span>
                      </v-flex>
                      <v-flex
                        v-if="0 > fisData.TotalBalance"
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f"
                          >{{ $t("Balance") }}:</span
                        >
                        {{ fixBalancePrice(fisData.TotalBalance) }}
                        <span class="green--text caption"
                          >{{ $t("Credit") }}
                        </span>
                      </v-flex>
                      <v-flex
                        v-if="0 == fisData.TotalBalance"
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f"
                          >{{ $t("Balance") }}:</span
                        >
                        0
                      </v-flex>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f"
                          >{{ $t("E-Ledger-Printed") }} :</span
                        >
                        {{  fisData.BookCreateDate | dateformat }}
                       
                      </v-flex>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f">
                          {{ $t("E-Ledger-Sent") }} :</span
                        >
                        {{ fisData.EBookSendDate | dateformat }}
                      </v-flex>
                       <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                        ><span style="color: #67768f">
                          {{ "Yevmiye No:" }} :</span
                        >
                      <span v-if="fisData.RegistryItemNo!=0"> {{ fisData.RegistryItemNo  }}</span> 
                      </v-flex>
                    </v-flex>

                    <v-flex xs12 sm6 md1 pr-2>
                      <v-layout row wrap>
                        <v-flex xs6 sm6 md6 shrink>
                          <v-tooltip bottom>
                            <v-btn
                              icon
                              medium
                              slot="activator"
                              flat
                              @click="openUpdateFisDialog()"
                            >
                              <v-icon color="info" medium
                                >system_update_alt</v-icon
                              >
                            </v-btn>
                            <span>Fis Guncelle</span>
                          </v-tooltip>
                        </v-flex>

                        <v-flex xs6 sm6 md6 shrink>
                          <v-tooltip bottom>
                            <v-btn
                              icon
                              medium
                              slot="activator"
                              flat
                              @click="deleteFisDialogOpen(item)"
                            >
                              <v-icon color="warning" medium>delete</v-icon>
                            </v-btn>
                            <span>Fis Sil</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <v-flex
                        xs12
                        sm12
                        md12
                        class="font-weight-large grey--text caption"
                      >
                        <span style="color: #67768f">Fis Aciklama:</span>
                        {{ fisData.RecieptTitle }}
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-container>
            
<v-flex
  xs12
  sm12
  md12
  pl-4
  pb-3
  mr-4
  v-if="fisData.BadBalanceTypeMessage && fisData.BadBalanceTypeMessage!=''"
>
  <div class="bad-balance-box">
    <v-icon small class="mr-2">warning</v-icon>
    <span>{{ fisData.BadBalanceTypeMessage }}</span>
  </div>
</v-flex>
             
 
            <!-- Sıralama ve Filtreleme -->
            <v-flex xs12 sm12 md12 pt-2 pr-2>
              <v-card width="100%" flat color="grey lighten-5">
                <v-layout row wrap>
                  <v-layout row wrap align-center justify-start>
                    <v-flex xs12 sm12 md2>
                      <v-btn
                        medium
                        color="primary"
                        flat
                        @click="openAddDialog()"
                      >
                        {{ $t("Add-Line") }} <v-icon right medium>add</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs1 sm1 md1> </v-flex>
                    <v-flex xs12 sm12 md2>
                      <v-btn
                        medium
                        color="primary"
                        flat
                        @click="openInfoDialog()"
                      >
                        E - Defter Bilgileri <v-icon right medium>info</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap align-center justify-end>
                    <v-flex xs12 sm12 md4>
                      <v-select
                        :label="$t('Sort-By')"
                        :items="siralamaItems"
                        item-text="Text"
                        item-value="Value"
                        @change="getListPageZero()"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-card>
            </v-flex>

            <!--listeleme-->
            <v-container fluid grid-list-sm>
              <v-flex xs12 sm12 md12>
                <v-data-table :headers="headersLines" :items="fisData.Lines">
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td class="text-xs-left">
                        {{ props.item.AccountingCode.Code }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.AccountingCode.CodeName }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.DocumentType }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.DocumentNo }}
                      </td>
                      <td class="text-xs-left">
                        <span
                          v-if="!props.item.DeptCredit"
                          class="font-weight-large red--text body-2"
                        >
                          {{ props.item.LinePrice | moneyformat }}
                        </span>
                        <span v-else class="font-weight-large red--text body-2">
                        </span>
                      </td>
                      <td class="text-xs-left">
                        <span
                          v-if="props.item.DeptCredit"
                          class="font-weight-large green--text body-2"
                        >
                          {{ props.item.LinePrice | moneyformat }}
                        </span>
                        <span v-else class="font-weight-large red--text body-2">
                        </span>
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Explanation1 }} &nbsp;
                        {{ props.item.Explanation2 }} &nbsp;
                        {{ props.item.Explanation3 }}
                      </td>

                      <td class="text-xs-right">
                        <v-btn
                          icon
                          medium
                          slot="activator"
                          flat
                          @click="loadSatir(props.item)"
                        >
                          <v-icon color="info" medium>search</v-icon>
                        </v-btn>

                        <v-btn
                          icon
                          medium
                          slot="activator"
                          flat
                          @click="deleteSatirDialog(props.item)"
                        >
                          <v-icon color="warning" medium>delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-container>

            <!-- sayfalama -->
            <!-- <template v-if="vmodelpagination">
      <div class="text-xs-center">
        <v-container>
          <v-layout justify-center>
            <v-flex xs8>
              <v-pagination
                :disabled="paginationDisabled"
                color="info"
                v-model="sayfalama"
                :length="pagenumber"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </template> -->

            <v-layout row justify-center>
              <v-card color="grey lighten-5" flat>
                <v-flex xs12 sm12 md12 pa-2>
                  <satir
                    ref="satir"
                    :satirID="$route.query.fisID"
                    :lastData="lastLineData"
                    @loadFisAndContinue="loadFisAndContinue($event)"
                    @getLastValue="sendLastValue()"
                  ></satir>
                </v-flex>
              </v-card>
            </v-layout>
          </v-tab-item>

          <v-tab href="#1" v-if="this.$route.query.islem == 'get'">
            Geçmiş
          </v-tab>
          <v-tab-item
            :id="'1'"
            v-if="this.$route.query.islem == 'get'"
            style="width: 100%"
          >
            <v-layout row="" wrap="">
              <v-flex pa-1 xs12 sm12 md12>
                <v-card flat>
                  <v-data-table
                    :headers="headersLog"
                    :rows-per-page-items="[50, 100]"
                    :items="fisData.Logs"
                  >
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">
                          {{ props.item.UserName }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.ProcessDescription }}
                        </td>
                        <td class="text-xs-left">
                          {{ props.item.ProcessDate | dateformat }}
                          {{ props.item.ProcessDate | timeformat }}
                        </td>
                        <td class="text-xs-left">
                          <v-icon @click="openProcces(props.item.ProcessText)">
                            search</v-icon
                          >
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs>

        <v-layout row justify-center>
          <v-dialog v-model="dialogDelete" persistent max-width="290">
            <v-card>
              <v-card-title class="headline warning white--text"
                >Fis Sil</v-card-title
              >
              <v-card-text>Fisi silmek istiyor musunuz ?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  flat
                  @click.native="dialogDelete = false"
                >
                  {{ $t("cancel_button") }}
                </v-btn>
                <v-btn color="primary" flat @click="deleteFis()">
                  {{ $t("Delete") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <v-layout row justify-center>
          <v-dialog v-model="dialogSatirDelete" persistent max-width="290">
            <v-card>
              <v-card-title class="headline warning white--text"
                >Satir Sil</v-card-title
              >
              <v-card-text>Satiri silmek istiyor musunuz ?</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  flat
                  @click.native="dialogSatirDelete = false"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn color="primary" flat @click="deleteSatir()">
                  {{ $t("Delete") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <v-layout row justify-center>
          <v-dialog v-model="LogRequest" max-width="400px">
            <v-card>
              <v-card-title> {{ $t("Request-Detail") }} </v-card-title>
              <v-card-text>{{ LogRequestData }}</v-card-text>
              <v-card-actions
                ><v-btn @click="LogRequest = false"
                  >Kapat</v-btn
                ></v-card-actions
              >
            </v-card>
          </v-dialog>
        </v-layout>

        <v-layout row justify-center>
          <v-dialog v-model="dialogInfo" persistent max-width="490">
            <v-toolbar color="primary">
              <span class="headline white--text"> E Defter Bilgileri </span>
            </v-toolbar>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6>
                    <span class="subheading font-weight-regular">
                      {{ $t("Document-No-v2") }} :</span
                    >
                    <span class="body-1 font-weight-light">
                      {{ fisData.ERegistryDocNo }}
                    </span>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <span class="subheading font-weight-regular">
                      {{ $t("Document-Date") }} :
                    </span>
                    <span class="body-1 font-weight-light">
                      {{ fisData.ERegistryDocDate | dateformat }}
                    </span>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <span class="subheading font-weight-regular">
                      {{ $t("Payment-Type") }} :
                    </span>
                    <span class="body-1 font-weight-light">
                      {{ fisData.ERegistryPaymentType }}
                    </span>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <span class="subheading font-weight-regular">
                      {{ $t("Document-Type-v3") }} :
                    </span>
                    <span class="body-1 font-weight-light">
                      {{ getDocType(fisData.ERegisrtyDocType) }}
                    </span>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <span class="subheading font-weight-regular">
                      {{ $t("Description") }} :
                    </span>
                    <span class="body-1 font-weight-light">
                      {{ fisData.ERegistryDocExplain }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  flat
                  @click.native="dialogInfo = false"
                  >{{ $t("Close") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-flex>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihim from "@/components/app/customcomp/tarihim";
import satir from "../comp/satir.vue";
import auth from "@/api/auth";
import fis from "../comp/fis.vue";

export default {
  data() {
    return {
      showLeaveModal: false,
  nextRoute: null,
  
      ListParams: {
        RecieptNumberStart : 0,
        RecieptNumberEnd: 0,
        TotalPriceSub: null,
        TotalPriceTop: null,
        UserID: 0,
        RecieptID: 0,
        RecieptLineID: 0,
        FirstDate: null,
        LastDate: null,
        NoShowLines: true,
        RecieptExplain: null,
        RecieptType: null,
        AccountingCenter: null,
        SearchType: 0,
        CompanyID: 0,
        BadReciepts:0,
        Paging: {
          PageNo: 1,
          DataCount: 25,
          OrderType: 1,
        },
      },
      lastLineData: null,
      dialogInfo: false,
      LogRequest: false,
      LogRequestData: null,
      modelActive: null,
      headersLines: [
        {
          text: "Hesap No",
        },
        {
          text: "Hesap Adı",
        },
        {
          text: "Evrak Tipi",
        },
        {
          text: "Evrak No",
        },
        {
          text: "Borç",
        },
        {
          text: "Alacak",
        },
        {
          text: "Açıklama",
        },
        {
          text: "İşlem",
          align: "right",
        },
      ],
      headersLog: [
        {
          text: this.$t("User"),
        },
        {
          text: this.$t("Process"),
        },
        {
          text: this.$t("Transaction-Date"),
        },
        {
          text: this.$t("Transaction-details"),
        },
      ],
      satirDeleteID: 0,
      dialogSatirDelete: false,
      dialogDelete: false,
      dialogAdd: false,
      veriItem: [
        {
          Text: "25",
          Value: 25,
        },
        {
          Text: "50",
          Value: 50,
        },
        {
          Text: "100",
          Value: 100,
        },
      ],
      siralamaItems: [
        {
          Text: "Tarihi Artan",
          Value: 2,
        },
        {
          Text: this.$t("Date-Decreasing"),
          Value: 3,
        },
      ],
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      fisData: null,
      lineList: [],
    };
  },
beforeRouteLeave(to, from, next) {
  var dept = 0;
  var credit = 0;

  if (this.fisData && this.fisData.TotalDept != null) {
    dept = Number(this.fisData.TotalDept);
  }

  if (this.fisData && this.fisData.TotalCredit != null) {
    credit = Number(this.fisData.TotalCredit);
  }

  if (dept !== credit) {
    this.showLeaveModal = true;
    this.nextRoute = next;   
  } else {
    next();                  
  }
},
  methods: {
  confirmLeave() {
    this.showLeaveModal = false;
    if (this.nextRoute) this.nextRoute();   
    this.nextRoute = null;
  },
  cancelLeave() {
    this.showLeaveModal = false;
    if (this.nextRoute) this.nextRoute(false); 
    this.nextRoute = null;
  },
 
  beforeUnload(e) {
   
    if (this.a !== this.b) {
      e.preventDefault();
      e.returnValue = "";
    }
  },
    getListHtml() {
      this.ListParams.FirstDate = this.fisData.RecieptDate;
        this.ListParams.LastDate = this.fisData.RecieptDate;
        this.ListParams.RecieptNumberStart=this.fisData.RecieptNumber;
        this.ListParams.RecieptNumberEnd=this.fisData.RecieptNumber;
     
       this.ListParams.CompanyID = this.credentials.MuhasebeSirketNo;
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptListHtml",
          this.ListParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
            responseType: "arraybuffer",
          }
        )
        .then(
          (response) => {
            
            
            var blob = new Blob([response.data], {
              type: "application/html",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeFis.html";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getListExcel() {
       this.ListParams.FirstDate = this.fisData.RecieptDate;
        this.ListParams.LastDate = this.fisData.RecieptDate;
        this.ListParams.RecieptNumberStart=this.fisData.RecieptNumber;
        this.ListParams.RecieptNumberEnd=this.fisData.RecieptNumber;
     
       this.ListParams.CompanyID = this.credentials.MuhasebeSirketNo;
     
      this.loadingvmodel = true;

      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptListExcel",
          this.ListParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
            responseType: "arraybuffer",
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/xlsx",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeFis.xlsx";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    sendLastValue() {
      this.lastLineData = this.fisData.Lines[this.fisData.Lines.length - 1];
      this.$refs.satir.setLastValue(this.lastLineData);
    },
    getDocType(val) {
      switch (val) {
        case 0:
          return this.$t("Check");
        case 1:
          return this.$t("Bill");
        case 2:
          return this.$t("Customer-Order");
        case 3:
          return this.$t("Seller-Order");
        case 4:
          return this.$t("Note-v2");
        case 5:
          return this.$t("Freight");
        case 6:
          return this.$t("Receipt-v2");
        case 7:
          return this.$t("Other");
        default:
          break;
      }
    },
    openInfoDialog() {
      this.dialogInfo = true;
    },
    openProcces(dialogText) {
      this.LogRequest = true;
      this.LogRequestData = dialogText;
    },
    desingLineNumber(val) {
      if (typeof val != "undefined") {
        switch (val.toString().length) {
          case 1:
            return "00000" + val;
          case 2:
            return "0000" + val;
          case 3:
            return "000" + val;
          case 4:
            return "00" + val;
          case 5:
            return "0" + val;
          case 6:
            return val;
          default:
            break;
        }
      }
    },
    desingRecieptNumber(val) {
      if (typeof val != "undefined") {
        switch (val.toString().length) {
          case 1:
            return "000000000" + val;
          case 2:
            return "00000000" + val;
          case 3:
            return "0000000" + val;
          case 4:
            return "000000" + val;
          case 5:
            return "00000" + val;
          case 6:
            return "0000" + val;
          case 7:
            return "000" + val;
          case 8:
            return "00" + val;
          case 9:
            return "0" + val;
          case 10:
            return val;
          default:
            break;
        }
      }
    },
    fixBalancePrice(val) {
      var result = val.toString().substring(1);
      return Number(result).toFixed(2);
    },
    loadSatir(val) {
      this.$refs.satir.updateDialog(val);
    },
    deleteSatirDialog(val) {
      this.satirDeleteID = val.RecieptLineID;
      this.dialogSatirDelete = true;
    },
    deleteSatir() {
      let params = {
        UserID: this.credentials.UserID,
        RecieptID: this.$route.query.fisID,
        RecieptLineID: this.satirDeleteID,
        FirstDate: null,
        LastDate: null,
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptLineDelete",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
              this.Loadfis(this.$route.query.fisID);
              this.dialogSatirDelete = false;
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptLineDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RecieptLineDelete";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    deleteFis() {
      let params = {
        UserID: this.credentials.UserID,
        RecieptID: this.$route.query.fisID,
        RecieptLineID: 0,
        FirstDate: null,
        LastDate: null,
      };
      this.$http
        .post(auth.API_URL + "api/AccountingReciepts/RecieptDelete", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            if (response.body.Status) {
              var url = "#/muhasebe/fisler/liste";
              window.open(url, "_self");
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptLoad";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-RecieptLoad";
              this.snackbar = true;
            }
          }
        );
    },
    deleteFisDialogOpen() {
      this.dialogDelete = true;
    },
    openUpdateFisDialog() {
      this.$refs.fis.updateDialog(this.fisData);
    },
    git() {
      var url = "#/muhasebe/fisler/islem";
      window.open(url, "_target");
    },
    openAddDialog() {
      this.$refs.satir.dialogOpen(this.fisData);
    },
    getList() {},
    getSatirList(fisID) {
      let params = {
        UserID: this.credentials.UserID,
        RecieptID: fisID,
        RecieptLineID: 0,
        FirstDate: null,
        LastDate: null,
      };
      this.$http
        .post(auth.API_URL + "api/AccountingReciepts/RecieptLineList", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.lineList = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptLoad";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-RecieptLoad";
              this.snackbar = true;
            }
          }
        );
    },
    loadFisAndContinue(fisID) {
      this.loadingvmodel = true;
      let params = {
        UserID: this.credentials.UserID,
        RecieptID: fisID,
        RecieptLineID: 0,
        FirstDate: null,
        LastDate: null,
      };
      this.$http
        .post(auth.API_URL + "api/AccountingReciepts/RecieptLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.fisData = response.body;
            this.$refs.satir.dialogAddContinue(this.fisData);
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.loadingvmodel = false;
              this.text1 = "Service Unavailable-RecieptLoad";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-RecieptLoad";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
    Loadfis(fisID) {
      this.loadingvmodel = true;
      let params = {
        UserID: this.credentials.UserID,
        RecieptID: fisID,
        RecieptLineID: 0,
        FirstDate: null,
        LastDate: null,
      };
      this.$http
        .post(auth.API_URL + "api/AccountingReciepts/RecieptLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.fisData = response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.loadingvmodel = false;
              this.text1 = "Service Unavailable-RecieptLoad";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-RecieptLoad";
              this.loadingvmodel = false;
              this.snackbar = true;
            }
          }
        );
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihim,
    satir,
    fis,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeDestroy() {
  window.removeEventListener("beforeunload", this.beforeUnload);
},
  mounted() {
    window.addEventListener("beforeunload", this.beforeUnload);
    // this.getSatirList(this.$route.query.fisID);
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status == true) {
      this.Loadfis(this.$route.query.fisID);
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    timeformat: function (t) {
      return helpers.getTime(t);
    },
  },
};
</script>

<style scoped>
.ustYazi {
  margin-top: 20px;
}
.bad-balance-box {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid #ff9800;
  border-radius: 8px;
  background-color: #fff3e0;
  color: #e65100;
  font-weight: 500;
}
</style>

